export default "__VITE_ASSET__BPVdt42R__"